import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.sass'],
})
export class RegisterComponent implements OnInit {
  roles: any = ['Master', 'Admin'];
  login = {
    name: '',
    email: '',
    password: '',
  };

  constructor() {}

  ngOnInit() {}
}
